import React, { useEffect, useRef, useState } from 'react';
import close from '../../assets/icons/close.svg';
import next from '../../assets/icons/icon.svg';
import { VerifyDiscountPayment } from './VerifyDiscountPaymentModel';
import { getData, Postdata, Postdataform } from '../../API/GlobalApi';
import StudentSearch from '../SearchStudent';
import useAutoFocus from '../../Utils/autoFocus';
import { numberToWords } from '../../Utils/convertNumtoWord';
import '../../assets/css/Modal.css'
import Select from 'react-select';
import { SuccessfulModalPayment } from './SuccessfulModalPayment';
import { reactSelectStyles } from '../../Utils/selectBoxStyle';
import '../../assets/css/StudentShortDetails.css'
import Notifier from '../../Utils/notify';
import { formatDateDDMMYYYY, formatDateDDMMYYYYHHMMSS, formatDateDDMMYYYYHHMMSS_UTC, parseDDMMYYYYHHMMSS } from '../../Utils/data&dateTime';
import SpinnerLoader from '../../Utils/Spinner';
import { useHasPermission } from '../../Utils/checkPermissions';
import { useFocusTrap } from '../../Utils/TabIndexingFocus';
export const ReceivePayment = ({
    isReceivedPaymentModalOpen,
    onClose, modeOfPayment, getStudents, currentPage, getTransactions, getTransactionStats, getFeeReceivedData, currentPageFeeReceive
}) => {

    const [amount, setAmount] = useState('');
    const [discountValue, setDiscountValue] = useState('');
    const [isPercentage, setIsPercentage] = useState(false);
    const [discountVerified, setDiscountVerified] = useState(false);
    const [showDiscountModal, setShowDiscountModal] = useState(false);
    const [studentsData, setStudentsData] = useState([]);
    const [selectedStudentId, setSelectedStudentId] = useState(null);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [employeeName, setEmployeeName] = useState('');
    const nameInputRef = useAutoFocus(isReceivedPaymentModalOpen);
    const [selectedEmployeeId, setSelectedEmployeeId] = useState(null);
    const [paymentDate, setPaymentDate] = useState(new Date().toISOString().split('T')[0]);
    const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
    const [discountObjectId, setDiscountObjectId] = useState(null)
    const [feeType, setFeeType] = useState('');
    const [semesterName, setSemsterName] = useState('')
    const [paymentmodal, setpaymentmodal] = useState(false);
    const [paymentResponse, setPaymentResponse] = useState(null)
    const [triggerGetStudentData, setTriggerGetStudentData] = useState(false);
    const [shouldCloseAfterPayment, setShouldCloseAfterPayment] = useState(false);
    const [paymentTypes, setPaymentTypes] = useState([])
    const [chequeNumber, setChequeNumber] = useState('');
    const [bankName, setBankName] = useState('');
    const [ifscCode, setIfscCode] = useState('');
    const [chequeDate, setChecqueDate] = useState('');
    const [chequeImage, setChequeImage] = useState(null);
    const [ddNumber, setDdNumber] = useState('');
    const [issueingBankBranchName, setIssueingBankBranchName] = useState('');
    const [ddissuingDate, seDdtIssuingDate] = useState('');
    const [ddpayeeName, setDdPayeeName] = useState('');
    const [payAbleAt, setPayAbleAt] = useState('')
    const [ddImage, setDDImage] = useState(null);
    const [utrNumber, setUtrNumber] = useState('');
    const [utrNumberUpiInBank, setUtrNumberUpiInBank] = useState('');
    const [showLedger, setShowLedger] = useState(false);
    const ledgerEntries = studentsData?.finance_data?.ledger_entries || [];
    const [bankNames, setBankNames] = useState()
    const [selectedBank, setSelectedBank] = useState(null);
    const [closePaymentOnSuccess, setClosePaymentOnSuccess] = useState(false);
    const [cashBankAccount, setCashBankAccount] = useState(null);
    const [upiInBankAccount, setUpiInBankAccount] = useState(null);
    const [cashDepositSlip, setCashDepositSlip] = useState(null);
    const [upinInBankDepositSlip, setUpiInBankDepositSlip] = useState(null)
    const [chequeBankAccount, setChequeBankAccount] = useState(null);
    const [chequeDepositSlip, setChequeDepositSlip] = useState(null);
    const [ddBankAccount, setDdBankAccount] = useState(null);
    const [ddDepositSlip, setDdDepositSlip] = useState(null);

    const [ddIssuingDate, setDdIssuingDate] = useState('');
    const [selectedBankAccount, setSelectedBankAccount] = useState(null);

    const trapRef = useFocusTrap(isReceivedPaymentModalOpen);
    const [chequeBankId, setChequeBankId] = useState('');
    const [ddBankId, setDdBankId] = useState('');
    const [issuingBranchId, setIssuingBranchId] = useState('');


    const bankOptions = bankNames?.map(bank => ({
        value: bank.id,
        label: bank.name
    }));
    const paymentModeRef = useRef(null);
    const amountRef = useRef(null);


    useEffect(() => {
        if (studentsData?.user_id) {
            setTimeout(() => {
                paymentModeRef.current?.focus();
                paymentModeRef.current?.openMenu();
            }, 100);
        }
    }, [studentsData]);

    const isCrmStudent = studentsData?.profile_name === 'CRM Student';
    const crmInquiryAmount = studentsData?.career_arc_inquiry?.amount;

    useEffect(() => {
        if (isCrmStudent && crmInquiryAmount != null) {
            const numeric = Number(crmInquiryAmount);
            if (Number.isFinite(numeric)) {
                setAmount(String(Math.round(numeric)));
            }
        }
    }, [isCrmStudent, crmInquiryAmount]);



    // Combine Debit & Credit entries with type
    // const unifiedEntries = ledgerEntries.map((e) => ({
    //     ...e,
    //     entryType: e.payment_type === "Debit" ? "Debit" : "Credit",
    //     sortDate: e.payment_type === "Debit" ? e.due_date : e.payment_date, // use due_date for debit, payment_date for credit
    // }));

    // Sort by date (latest first)
    const unifiedEntries = ledgerEntries
        .map((e) => ({
            ...e,
            entryType: e.payment_type === "Debit" ? "Debit" : "Credit",
            sortDate: e.payment_type === "Credit" && e.payment_date
                ? e.payment_date
                : e.created_at, // Use payment_date for Credit if exists, else fallback
        }))
        // Sort by sortDate ascending → oldest first
        .sort((a, b) => new Date(a.sortDate) - new Date(b.sortDate));


    let totalDebit = 0;
    let totalCredit = 0;

    unifiedEntries.forEach((item) => {
        if (item.entryType === "Debit") totalDebit += item.amount;
        if (item.entryType === "Credit") totalCredit += item.amount;
    });

    // Final Balance = total credit – total debit
    let finalBalance = totalCredit - totalDebit;




    const [bankAccountOptions, setBankAccountOptions] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [bankResponse, feeTypesResponse, bankDetailsResponse] = await Promise.all([
                    getData("finance/institution-bank-accounts/"),
                    getData("students/get-payment-types/"),
                    getData("staff/teacher-official-details/get-master-data/")
                ]);

                // 👉 Bank Accounts
                if (Array.isArray(bankResponse)) {
                    const options = bankResponse.map((acc) => ({
                        value: acc.id,
                        label: `A/C: ${acc.account_number} - ${acc.account_holder_name} - ${acc.bank_name}`,
                        isDefault: acc.is_default,
                    }));

                    setBankAccountOptions(options);

                    // 👉 Auto select default account in ALL payment modes
                    const defaultAcc = options.find((acc) => acc.isDefault);
                    if (defaultAcc) {
                        setChequeBankAccount(defaultAcc);
                        setDdBankAccount(defaultAcc);
                        setCashBankAccount(defaultAcc);
                        setUpiInBankAccount(defaultAcc)

                        handleInputChange("chequeBankAccount", defaultAcc);
                        handleInputChange("ddBankAccount", defaultAcc);
                        handleInputChange("cashBankAccount", defaultAcc);
                        handleInputChange("upiInBankAccount", defaultAcc);
                    }
                }

                // 👉 Fee Types
                const feeTypeOptions =
                    feeTypesResponse?.payment_types?.map((type) => ({
                        label: type,
                        value: type,
                    })) || [];
                setPaymentTypes(feeTypeOptions);

                // 👉 Bank Names (from master data)
                setBankNames(bankDetailsResponse?.master?.banks || []);

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);



    useEffect(() => {
        const handleEscKey = (e) => {
            if (e.key === "Escape" && isReceivedPaymentModalOpen) {
                const cancelModes = ["Card", "UPI", "Wallet", "EMI"];

                if (cancelModes.includes(selectedPaymentMode?.value)) {
                    cancelCardPayment();
                } else {
                    handleModalClose();
                }
            }
        };

        window.addEventListener("keydown", handleEscKey);

        return () => {
            window.removeEventListener("keydown", handleEscKey);
        };
    }, [isReceivedPaymentModalOpen, selectedPaymentMode]);



    const [resetSearchKey, setResetSearchKey] = useState(0);
    const [errors, setErrors] = useState({});
    const validateField = (name, value) => {
        let message = "";

        switch (name) {
            case "accountNumber":
                if (!value.trim()) {
                    message = "Account number is required.";
                } else if (!/^[0-9]{9,18}$/.test(value)) {
                    message = "Account number must be 9 to 18 digits.";
                }
                break;

            case "ifscCode":
                if (!value.trim()) {
                    message = "IFSC code is required.";
                } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(value.toUpperCase())) {
                    message = "Invalid IFSC format (e.g., SBIN0001234).";
                }
                break;
            case "holderName":
                if (!value.trim()) {
                    message = "Account holder name is required.";
                } else if (!/^[A-Za-z\s]{3,50}$/.test(value)) {
                    message = "Name must be alphabets only (3-50 chars).";
                }
                break;

            case "chequeNumber":
                if (!value.trim()) {
                    message = "Cheque number is required.";
                } else if (!/^[0-9]{6}$/.test(value)) {
                    message = "Cheque number must be 6 digits.";
                }
                break;
            case "ddNumber":
                if (!value.trim()) {
                    message = "Demand Draft number is required.";
                } else if (!/^[0-9]{6,9}$/.test(value)) {
                    message = "DD number must be 6–9 digits.";
                }
                break;
            case "utrNumber":
                if (!value.trim()) {
                    message = "UTR number is required.";
                } else if (!/^[A-Z0-9/_-]{12,30}$/.test(value.toUpperCase())) {
                    message = "UTR must be 12–30 characters (alphanumeric, /, -, _).";
                }

                break;
            case "utrNumberUpiInBank":
                const utr = value.trim();

                if (!utr) {
                    message = "UTR number is required.";
                } else if (!/^[A-Z0-9_\-\/.]{12,50}$/i.test(utr)) {
                    message = "Transaction Number must be 12–50 characters (A–Z, 0–9, _, -, /, .).";
                }
                break;

            case "upinInBankDepositSlip":
                if (!value) return "File is required.";
                const allowedTypesUpiInBankDepositSlip = ["image/jpeg", "image/png", "application/pdf"];
                if (!allowedTypesUpiInBankDepositSlip.includes(value.type)) {
                    return "Only JPG, PNG, or PDF files are allowed.";
                }
                if (value.size > 2 * 1024 * 1024) { // 2 MB
                    return "File size must be less than 2MB.";
                }
                break;

            case "bankName":
                if (!value.trim()) {
                    message = "Bank name is required.";
                }
                break;
            case "ddNumber":
                if (!value) return "DD Number is required.";
                if (!/^[0-9]{6,9}$/.test(value)) return "DD Number must be 6–9 digits.";
                break;
            case "bankName":
                if (!value) return "Bank Name is required.";
                if (value.length < 3) return "Bank Name must be at least 3 characters.";
                if (!/^[A-Za-z\s]+$/.test(value)) return "Bank Name should contain only letters.";
                break;

            case "chequeImage":
            case "ddImage":
                if (!value) return "File is required.";
                const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
                if (!allowedTypes.includes(value.type)) {
                    return "Only JPG, PNG, or PDF files are allowed.";
                }
                if (value.size > 2 * 1024 * 1024) { // 2 MB
                    return "File size must be less than 2MB.";
                }
                break;
            case "issueingBankBranchName":
                if (!value.trim()) {
                    message = "Issuing Branch Name is required.";
                } else if (value.length < 3) {
                    message = "Branch Name must be at least 3 characters.";
                } else if (!/^[A-Za-z0-9\s,.-]+$/.test(value)) {
                    message = "Branch Name should contain only letters, numbers, spaces, commas, or dashes.";
                }
                break;

            case "payAbleAt":
                if (!value.trim()) {
                    message = "Payable At is required.";
                } else if (value.length < 3) {
                    message = "Payable At must be at least 3 characters.";
                } else if (!/^[A-Za-z\s]+$/.test(value)) {
                    message = "Payable At should contain only letters.";
                }
                break;
            case "bankAccount":
                if (!value) {
                    message = "Bank account is required.";
                }
                break;

            case "chequeDate":
            case "ddissuingDate":
                if (!value) {
                    message = "Date is required.";
                }
                break;

            case "cashBankAccount":
                if (!value) {
                    setErrors((prev) => ({ ...prev, cashBankAccount: "Bank Account is required." }));
                } else {
                    setErrors((prev) => ({ ...prev, cashBankAccount: "" }));
                }
                setCashBankAccount(value); // ✅ update state properly
                break;


            case "upiInBankAccount":
                if (!value) {
                    setErrors((prev) => ({ ...prev, upiInBankAccount: "Bank Account is required." }));
                } else {
                    setErrors((prev) => ({ ...prev, upiInBankAccount: "" }));
                }
                setUpiInBankAccount(value); // ✅ update state properly
                break;

            default:
                break;
        }

        return message;
    };
    const handleInputChange = (field, value) => {
        switch (field) {
            // Cheque fields
            case "chequeNumber":
                setChequeNumber(value.replace(/\D/g, "")); // only digits
                break;
            case "chequeBankId": // updated to ID
                setChequeBankId(value); // store bank ID directly
                break;
            case "ifscCode":
                setIfscCode(value.toUpperCase());
                break;
            case "chequeDate":
                setChecqueDate(value);
                break;
            case "chequeImage":
                setChequeImage(value); // file object
                break;

            // Demand Draft fields
            case "ddNumber":
                setDdNumber(value.replace(/\D/g, "")); // only digits
                break;
            case "ddBankId": // updated to ID
                setDdBankId(value); // store bank ID
                break;
            case "issuingBranchId": // updated to ID
                setIssuingBranchId(value); // store branch ID
                break;

            case "ddIssuingDate":
                setDdIssuingDate(value);
                break;

            case "ddpayeeName":
                setDdPayeeName(value.replace(/[^a-zA-Z\s]/g, ""));
                break;
            case "payAbleAt":
                setPayAbleAt(value.replace(/[^a-zA-Z\s]/g, ""));
                break;
            case "ddImage":
                setDDImage(value); // file object
                break;
            case "cashBankAccount":
                if (!value) return "Bank Account is required.";
                break;
            case "upiInBankAccount":
                if (!value) return "Bank Account is required.";
                break;
            case "cashDepositSlip":
                if (!value) return "Deposit Slip is required.";
                const allowedTypes2 = ["image/jpeg", "image/png", "application/pdf"];
                if (!allowedTypes2.includes(value.type)) {
                    return "Only JPG, PNG, or PDF files are allowed.";
                }
                if (value.size > 2 * 1024 * 1024) {
                    return "File size must be less than 2MB.";
                }
                break;

            // NEFT / RTGS 

            case "utrNumber":
                setUtrNumber(value.toUpperCase());
                break;

            case "utrNumberUpiInBank":
                setUtrNumberUpiInBank(value.toUpperCase());
                break;


            case "upinInBankDepositSlip":
                if (!value) return "Deposit Slip is required.";
                const allowedTypesUTR = ["image/jpeg", "image/png", "application/pdf"];
                if (!allowedTypesUTR.includes(value.type)) {
                    return "Only JPG, PNG, or PDF files are allowed.";
                }
                if (value.size > 2 * 1024 * 1024) {
                    return "File size must be less than 2MB.";
                }
                break;


            case "chequeBankAccount":
                if (!value) return "Bank Account is required.";
                break;

            case "chequeDepositSlip":
                if (!value) return "Deposit Slip is required.";
                const allowedTypes3 = ["image/jpeg", "image/png", "application/pdf"];
                if (!allowedTypes3.includes(value.type)) {
                    return "Only JPG, PNG, or PDF files are allowed.";
                }
                if (value.size > 2 * 1024 * 1024) {
                    return "File size must be less than 2MB.";
                }
                break;
            case "ddBankAccount":
                if (!value) return "Bank Account is required.";
                break;

            case "ddDepositSlip":
                if (!value) return "Deposit Slip is required.";
                const allowedTypes4 = ["image/jpeg", "image/png", "application/pdf"];
                if (!allowedTypes4.includes(value.type)) {
                    return "Only JPG, PNG, or PDF files are allowed.";
                }
                if (value.size > 2 * 1024 * 1024) {
                    return "File size must be less than 2MB.";
                }
                break;

            case "bankAccount":
                setSelectedBankAccount(value);
                break;

            default:
                break;
        }

        // validate immediately
        const errorMsg = validateField(field, value);
        setErrors((prev) => ({ ...prev, [field]: errorMsg }));
    };

    const handleModalClose = () => {
        onClose()
        setStudentsData([]);
        setSelectedPaymentMode(null)
        setFeeType('');
        setShouldCloseAfterPayment(false);
        setpaymentmodal(false);
        setSemsterName('');
        setSelectedStudent(null);
        setSelectedStudentId(null);
        setAmount('');
        setDiscountValue('');
        setIsPercentage(false);
        setDiscountVerified(false);
        setSelectedEmployeeId(null);
        setEmployeeName('');
        setResetSearchKey(prev => prev + 1);
    }


    const values = {
        chequeNumber, chequeBankId, ifscCode, chequeImage, chequeDate, ddNumber, ddBankId, ddIssuingDate, ddpayeeName, payAbleAt,
        issuingBranchId, ddImage, ddDepositSlip, chequeBankAccount, chequeDepositSlip, ddBankAccount, ddDepositSlip, cashBankAccount, cashDepositSlip,
        utrNumber, utrNumberUpiInBank, upinInBankDepositSlip, upiInBankAccount
    };

    const validatePayment = (mode) => {
        const rules = {
            "Cheque": ["chequeNumber", "chequeBankId", "ifscCode", "chequeImage", "chequeDate"],
            "Demand Draft": ["ddNumber", "ddBankId", "ddIssuingDate", "ddpayeeName", "payAbleAt", "issuingBranchId", "ddImage"],
            "Cheque in Bank": ["chequeBankAccount", "chequeDepositSlip", "chequeNumber", "chequeBankId", "ifscCode", "chequeImage", "chequeDate"],
            "Demand Draft in Bank": [
                "ddBankAccount", "ddDepositSlip", "ddNumber", "ddBankId",
                "ddIssuingDate", "ddpayeeName", "payAbleAt", "issuingBranchId", "ddImage"
            ]
            ,
            "Cash in Bank": ["cashBankAccount", "cashDepositSlip"],
            "UPI in Bank": ["utrNumberUpiInBank", "upinInBankDepositSlip", "upiInBankAccount"],
            "NEFT": ["utrNumber", "cashBankAccount"],
            "RTGS": ["utrNumber", "cashBankAccount"],
            "IMPS": ["utrNumber", "cashBankAccount"],
        };

        if (!mode) {
            Notifier.error("Please select a mode of payment");
            return false;
        }

        const requiredFields = rules[mode];
        if (requiredFields) {
            for (let field of requiredFields) {
                if (!values[field] || (field === "cashBankAccount" && !values[field]?.value)) {
                    Notifier.error(`Please fill all ${mode} details.`);
                    return false;
                }
            }
        }
        return true;
    };


    const [loadingButton, setLoadingButton] = useState(null);

    const [showCancel, setShowCancel] = useState(false);

    const handleKeyPress = (e) => {
        if (e.key === "Enter" && amount && studentsData?.user_id) {
            e.preventDefault();
            handleReceiveFee("new");
        }
    };
    const handleReceiveFee = async (actionType) => {
        try {

            setLoadingButton(actionType);

            const today = new Date().toISOString();
            const mode = selectedPaymentMode?.value;

            if (!validatePayment(mode)) {
                setLoadingButton(null);
                return;
            }

            if (mode === "Card" || mode === "UPI" || mode === "Wallet" || mode === "EMI") {
                setShowCancel(true);
            } else {
                setShowCancel(false);
            }

            // ---------------- BUILD FORMDATA ----------------
            const formData = new FormData();
            formData.append("student_user_id", studentsData?.user_id);
            formData.append("payment_date", today);
            formData.append("payment_method", mode);
            formData.append("amount", parseFloat(amount));



            // ---------- Specific mode data ----------
            if (mode === "Cheque") {
                formData.append("cheque_number", chequeNumber);
                formData.append("bank_id", chequeBankId);
                formData.append("ifsc_code", ifscCode);
                formData.append("cheque_image", chequeImage);
                formData.append("cheque_date", chequeDate);
            }
            if (mode === "Demand Draft") {
                formData.append("dd_number", ddNumber);
                formData.append("bank_id", ddBankId);
                formData.append("issuing_branch", issuingBranchId);
                formData.append("date_of_issuing", ddIssuingDate);
                formData.append("payee_name", ddpayeeName);
                formData.append("payable_at", payAbleAt);
                formData.append("dd_image", ddImage);
            }
            if (mode === "Cheque in Bank") {
                formData.append("institution_bank_id", chequeBankAccount?.value);
                formData.append("deposit_slip", chequeDepositSlip);
                formData.append("cheque_number", chequeNumber);
                formData.append("bank_id", chequeBankId);
                formData.append("ifsc_code", ifscCode);
                formData.append("cheque_image", chequeImage);
                formData.append("cheque_date", chequeDate);
            }
            if (mode === "Demand Draft in Bank") {
                formData.append("institution_bank_id", ddBankAccount?.value);
                formData.append("deposit_slip", ddDepositSlip);
                formData.append("dd_number", ddNumber);
                formData.append("bank_id", ddBankId);
                formData.append("issuing_branch", issuingBranchId);
                formData.append("date_of_issuing", ddIssuingDate);
                formData.append("payee_name", ddpayeeName);
                formData.append("payable_at", payAbleAt);
                formData.append("dd_image", ddImage);
            }
            if (mode === "Cash in Bank") {
                formData.append("institution_bank_id", cashBankAccount?.value);
                formData.append("deposit_slip", cashDepositSlip);
            }

            if (mode === "UPI in Bank") {
                formData.append("institution_bank_id", upiInBankAccount?.value);
                formData.append("transaction_reference", utrNumberUpiInBank);
                formData.append("deposit_slip", upinInBankDepositSlip);
            }


            if (["NEFT", "RTGS", "IMPS"].includes(mode)) {
                formData.append("utr_number", utrNumber);
                formData.append("bank_id", cashBankAccount?.value);
            }

            // ---------------- API CALL ----------------
            const url = studentsData?.profile_name === "Student"
                ? "finance/payments/receive/"
                : "finance/payments/receive-non-student/";
            const response = await Postdataform(url, formData);
            console.log("resposnne", response)
            if (response?.error) {
                const errorMessage = `${response.error}${response.details ? `: ${response.details} is required` : ""}`;
                Notifier.error(errorMessage);
                if (actionType === "close") setpaymentmodal(false);
                return;
            }

            if (response?.message) {
                // UPI POS Initiated Case (No Success Modal Required) 
                if (
                    mode === "UPI" &&
                    response?.message === "POS Transaction Initiated Successfully."
                ) {
                    Notifier.success(response?.message);
                    setShowCancel(true);

                    // Refresh Data
                    getTransactions(currentPage);
                    getFeeReceivedData(currentPageFeeReceive);
                    getTransactionStats();

                    // RESET FORM
                    setStudentsData([]);
                    setSelectedPaymentMode(null);
                    setFeeType("");
                    setSemsterName("");
                    setSelectedStudent(null);
                    setSelectedStudentId(null);
                    setAmount("");
                    setDiscountValue("");
                    setIsPercentage(false);
                    setDiscountVerified(false);
                    setSelectedEmployeeId(null);
                    setEmployeeName("");
                    setResetSearchKey((prev) => prev + 1);
                    setChequeBankId("");
                    setDdBankId("");
                    setIssuingBranchId("");
                    setChequeNumber("");
                    setIfscCode("");
                    setChecqueDate("");
                    setChequeImage(null);
                    setDdNumber("");
                    setDdIssuingDate("");
                    setDdPayeeName("");
                    setPayAbleAt("");
                    setDDImage(null);
                    setUtrNumber("");
                    setUpiInBankDepositSlip("")
                    setUtrNumberUpiInBank("")
                    setChequeBankAccount(null);
                    setChequeDepositSlip(null);
                    setDdBankAccount(null);
                    setDdDepositSlip(null);
                    setCashBankAccount(null);
                    setCashDepositSlip(null);
                    setUpiInBankAccount(null)

                    // CLOSE ONLY IF actionType === "close"
                    if (actionType === "close") {
                        setpaymentmodal(false);
                        setTimeout(() => onClose(), 50);
                    }

                    setLoadingButton(null);
                    return; // stop further success modal logic
                }


                Notifier.success(response?.message);
                setShowCancel(false);
            }


            const enrichedResponse = {
                ...response?.data,
                studentsData,
            };
            setPaymentResponse(enrichedResponse);
            getTransactions(currentPage);
            getFeeReceivedData(currentPageFeeReceive)
            getTransactionStats();

            // ---------------- POST-ACTION ----------------
            if (actionType === "new") {
                setClosePaymentOnSuccess(false);
                setShouldCloseAfterPayment(false);
            } else {
                setShouldCloseAfterPayment(true);
                setClosePaymentOnSuccess(true);
                setTriggerGetStudentData(true);
            }

            setpaymentmodal(true);

            // ---------------- RESET FORM ----------------

            setStudentsData([]);
            setSelectedPaymentMode(null);
            setFeeType("");
            setSemsterName("");
            setSelectedStudent(null);
            setSelectedStudentId(null);
            setAmount("");
            setDiscountValue("");
            setIsPercentage(false);
            setDiscountVerified(false);
            setSelectedEmployeeId(null);
            setEmployeeName("");
            setResetSearchKey((prev) => prev + 1);

            // Reset cheque/dd/cash states
            setChequeBankId("");
            setDdBankId("");
            setIssuingBranchId("");
            setChequeNumber("");
            setIfscCode("");
            setChecqueDate("");
            setChequeImage(null);
            setDdNumber("");
            setDdIssuingDate("");
            setDdPayeeName("");
            setPayAbleAt("");
            setDDImage(null);
            setUtrNumber("");
            setUpiInBankDepositSlip("")
            setUtrNumberUpiInBank("")
            setChequeBankAccount(null);
            setChequeDepositSlip(null);
            setDdBankAccount(null);
            setDdDepositSlip(null);
            setCashBankAccount(null);
            setUpiInBankAccount(null)
            setCashDepositSlip(null);

        } catch (error) {

            Notifier.error(error?.response?.data?.message || "Failed to process payment. Please try again.");
        } finally {
            setLoadingButton(null);
        }
    };



    const cancelCardPayment = async () => {
        try {
            const url = "finance/stop-payment-polling/";
            const response = await getData(url);


            if (response?.success) {
                // Notifier.success(response.message || "Payment cancelled successfully");
            } else {
                Notifier.error(response?.error || "Failed to cancel payment");
            }
        } catch (error) {
            Notifier.error(error?.response?.data?.message || "Error cancelling payment");
        } finally {
            // Always close modal + reset after cancel attempt
            setShowCancel(false);

            handleModalClose();

        }
    };

    // useEffect(() => {
    //     if (paymentmodal) {
    //         const timer = setTimeout(() => {
    //             setpaymentmodal(false);
    //             if (shouldCloseAfterPayment) {
    //                 onClose();
    //             }
    //         }, 3000);
    //         return () => clearTimeout(timer);
    //     }
    // }, [paymentmodal]);

    const calculateTotal = () => {
        const amt = parseFloat(amount);
        const discountNum = parseFloat(discountValue);

        if (isNaN(amt) || amt <= 0) return 0;
        if (!discountVerified || isNaN(discountNum) || discountNum < 0) return amt;

        let discountAmount = isPercentage
            ? (amt * discountNum) / 100
            : discountNum;

        let total = amt - discountAmount;
        return total > 0 ? total : 0;
    };


    const isDisabled = !studentsData?.user_id || !amount || Number(amount) <= 0;

    // const modeOfPaymentOptions = modeOfPayment?.map((mode) => ({
    //     value: mode,
    //     label: mode,
    // }));


    const modeOfPaymentOptions = modeOfPayment
        ?.filter((mode) => mode !== "UPI in Bank")   // 👈 exclude here
        .map((mode) => ({
            value: mode,
            label: mode,
        }));
    const modeOfSemester = (studentsData?.academic_groups || []).map(item => ({
        value: item.id,
        label: item.name,
    }));




    const handleCopyPaymentUrl = async (id) => {

        const res = await getData(`finance/student-payment-link/?student_id=${id}`)

        if (res?.payment_link) {
            await navigator.clipboard.writeText(res.payment_link);
            Notifier.info("Got it! The payment link is copied — you can paste it anywhere to share.");
        } else {
            Notifier.error("No payment link found for this student.");
        }
    }
    const handleSharePaymentUrl = async (id) => {
        const res = await getData(`finance/student-payment-link/?student_id=${id}`);

        if (!res?.payment_link) {
            Notifier.error("No payment link found for this student.");
            return;
        }

        const paymentLink = res.payment_link;

        if (navigator.share) {
            try {
                await navigator.share({
                    title: "Student Payment Link",
                    text: "Here is the payment link:",
                    url: paymentLink,
                });
            } catch (error) {
                console.log("Share cancelled or failed:", error);
            }
        } else {
            Notifier.warning("Sharing is not supported on this device.");
        }
    };


    if (!isReceivedPaymentModalOpen) return null;

    const totalPayment = calculateTotal();


    return (
        <>


            <div className="modal-overlay">
                <div
                    className="modal-content recevingPaymentBody"
                    style={{
                        position: 'relative',
                        width: '70%',
                        display: 'flex',
                        flexDirection: 'column',
                        overflowY: 'auto',
                        height: '94vh'
                    }}
                    ref={trapRef}
                >
                    <div
                        className="modal-header-content"
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '10px',
                        }}
                    >
                        <h2 className="text-primary">Receive Payment</h2>
                        <button
                            className="close-btn"
                            onClick={() => {
                                const cancelModes = ["Card", "UPI", "Wallet", "EMI"];

                                if (cancelModes.includes(selectedPaymentMode?.value)) {
                                    cancelCardPayment(); // <-- call cancel API + close modal
                                } else {
                                    handleModalClose();  // <-- normal close/reset
                                }
                            }}

                        >
                            <img src={close} alt="close" />
                        </button>

                    </div>

                    <div
                    // className="modal-body custom-modal-body  "
                    // style={{
                    //     overflowY: selectedStudent ? 'scroll' : 'unset !important',
                    //     padding: '0 10px',
                    //     overflowX: 'hidden',
                    // }}
                    >
                        <div className="mb-4">
                            <div className="row">
                                <div className="col-md-12">
                                    <StudentSearch
                                        studentsData={studentsData}
                                        nameInputRef={nameInputRef}
                                        // onSelectStudent={handleStudentChange}
                                        resetTrigger={resetSearchKey}
                                        setStudentsData={setStudentsData}
                                    />
                                </div>
                            </div>
                        </div>
                        <div
                            className="row"
                            style={{ background: "#F9FAFC", padding: "10px" }}
                        >
                            <div
                                className="row"
                                style={{ background: "#F9FAFC", padding: "10px" }}
                            >
                                < div className="col-md-3">
                                    <h4 className="fm-pr-hd">DETAILS</h4>
                                </div>


                                {studentsData?.user_id && studentsData?.profile_name === 'Student' && (<div className="col-md-9 d-flex justify-content-end">
                                    <div
                                        className="d-flex align-items-center gap-3"
                                        style={{ cursor: "pointer" }}

                                    >
                                        <span className="d-flex align-items-center gap-1"
                                            style={{
                                                textDecoration: "underline",
                                                color: "#7F56DA",
                                                fontWeight: 500,
                                                fontSize: '14px'
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleCopyPaymentUrl(studentsData?.user_id);
                                            }}
                                            title='Copy Payment Link'
                                        >
                                            Payment Link
                                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="28"
                                                height="28"><g id="SVGRepo_bgCarrier" stroke-width="0"
                                                > <title>Copy Url</title>
                                                </g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15.24 2H11.3458C9.58159 1.99999 8.18418 1.99997 7.09054 2.1476C5.96501 2.29953 5.05402 2.61964 4.33559 3.34096C3.61717 4.06227 3.29833 4.97692 3.14701 6.10697C2.99997 7.205 2.99999 8.60802 3 10.3793V16.2169C3 17.725 3.91995 19.0174 5.22717 19.5592C5.15989 18.6498 5.15994 17.3737 5.16 16.312L5.16 11.3976L5.16 11.3024C5.15993 10.0207 5.15986 8.91644 5.27828 8.03211C5.40519 7.08438 5.69139 6.17592 6.4253 5.43906C7.15921 4.70219 8.06404 4.41485 9.00798 4.28743C9.88877 4.16854 10.9887 4.1686 12.2652 4.16867L12.36 4.16868H15.24L15.3348 4.16867C16.6113 4.1686 17.7088 4.16854 18.5896 4.28743C18.0627 2.94779 16.7616 2 15.24 2Z" fill="#7F56DA"></path> <path d="M6.6001 11.3974C6.6001 8.67119 6.6001 7.3081 7.44363 6.46118C8.28716 5.61426 9.64481 5.61426 12.3601 5.61426H15.2401C17.9554 5.61426 19.313 5.61426 20.1566 6.46118C21.0001 7.3081 21.0001 8.6712 21.0001 11.3974V16.2167C21.0001 18.9429 21.0001 20.306 20.1566 21.1529C19.313 21.9998 17.9554 21.9998 15.2401 21.9998H12.3601C9.64481 21.9998 8.28716 21.9998 7.44363 21.1529C6.6001 20.306 6.6001 18.9429 6.6001 16.2167V11.3974Z" fill="#7F56DA"

                                                ></path> </g></svg>
                                        </span>



                                        <svg viewBox="-0.5 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" width="28"
                                            height="28"

                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleSharePaymentUrl(studentsData?.user_id);
                                            }}><title>Copy & Share Url</title>
                                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M13.47 4.13998C12.74 4.35998 12.28 5.96 12.09 7.91C6.77997 7.91 2 13.4802 2 20.0802C4.19 14.0802 8.99995 12.45 12.14 12.45C12.34 14.21 12.79 15.6202 13.47 15.8202C15.57 16.4302 22 12.4401 22 9.98006C22 7.52006 15.57 3.52998 13.47 4.13998Z" stroke="#7F56DA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                                    </div>
                                </div>)}
                            </div>
                            {/* Left side */}
                            <div className="col-md-4">
                                <div className="student-details" style={{ textAlign: "left" }}>
                                    {studentsData?.profile_name === "Student" && (<div>
                                        <p className="sd-p">Reg No</p>
                                        <p className="n-p-t">
                                            {studentsData?.permanent_registration_number}
                                        </p>
                                    </div>)}

                                    <div>
                                        <p className="sd-p">Name</p>
                                        {studentsData?.profile_name === "Student" && (
                                            <p className="n-p-t">
                                                {[
                                                    studentsData?.salutation,
                                                    studentsData?.first_name,
                                                    studentsData?.middle_name,
                                                    studentsData?.last_name
                                                ]
                                                    .filter(item => item && item.trim() !== "")
                                                    .join(" ")}
                                            </p>)}
                                        {studentsData?.profile_name !== "Student" && (
                                            <p className="n-p-t">
                                                {studentsData?.full_name}
                                            </p>)}

                                    </div>

                                    <div>
                                        <p className="sd-p">Contact No</p>
                                        <p className="n-p-t">{studentsData?.mobile}</p>
                                    </div>

                                </div>
                            </div>

                            {/* Right side */}
                            <div className="col-md-4 d-flex flex-column ">


                                <div>
                                    <p className="sd-p">Profile type</p>
                                    <p className="n-p-t">{studentsData?.profile_name}</p>
                                </div>


                                {studentsData.profile_name === "Student" && (<div>
                                    <p className="sd-p">Course</p>
                                    <p className="n-p-t">{studentsData?.lag?.display}</p>
                                </div>)}


                                {studentsData.profile_name === "Student" && (<div>
                                    <p
                                        className="mt-3"
                                        style={{ color: "#7f56da", fontWeight: "bold" }}  >
                                        Balance
                                    </p>
                                    <p
                                        style={{
                                            color:
                                                Number(studentsData?.finance_data?.financial_summary?.outstanding_balance) < 0
                                                    ? "red"
                                                    : "green",
                                            fontWeight: "600"
                                        }}
                                    >
                                        {studentsData?.finance_data?.financial_summary?.outstanding_balance}
                                    </p>
                                </div>)}
                            </div>

                            <div className="col-md-4 d-flex justify-content-center">
                                {studentsData?.profile_picture?.url && (
                                    <img
                                        src={`${process.env.REACT_APP_API_BASE_URL}${studentsData?.profile_picture?.url}`}
                                        alt="Student"
                                        style={{
                                            width: "120px",
                                            height: "120px",
                                            objectFit: "cover",
                                            borderRadius: "8px",
                                            marginBottom: "15px"
                                        }}
                                    />
                                )}

                            </div>
                        </div>
                        <div
                            className="row mt-3 d-flex justify-content-center m-auto"
                            style={{ maxWidth: '90%' }}
                        >
                            <div className="col-md-10">
                                <div
                                    className="payment-form"
                                    style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
                                >

                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="form-labell">
                                                Mode of Payment
                                                <span className="astrisk">*</span>
                                            </label>
                                        </div>
                                        <div className="col-md-8">
                                            <Select
                                                id="paymentMode"
                                                className="basic-single"
                                                classNamePrefix="select"
                                                options={modeOfPaymentOptions}
                                                ref={paymentModeRef}
                                                value={selectedPaymentMode}
                                                onChange={(value) => {
                                                    setSelectedPaymentMode(value);

                                                    // Focus amount field
                                                    setTimeout(() => {
                                                        amountRef.current?.focus();
                                                    }, 50);
                                                }}
                                                menuPlacement="auto"
                                                menuPosition="fixed"
                                                isSearchable
                                                placeholder="Select Payment Mode"
                                                styles={{
                                                    ...reactSelectStyles,
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 999999999, // very high
                                                    }),

                                                }}
                                                menuPortalTarget={null} // 👈 stop attaching to document.body
                                            />
                                        </div>
                                    </div>
                                    {selectedPaymentMode?.value === "Cash in Bank" && (
                                        <>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Select Bank Account<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <Select
                                                        options={bankAccountOptions}
                                                        value={cashBankAccount}
                                                        onChange={(selected) => {
                                                            setCashBankAccount(selected); // ✅ store full selected object
                                                            handleInputChange("cashBankAccount", selected);
                                                        }}
                                                        placeholder="Choose Cash Bank Account..."
                                                        className="react-select-container"
                                                        classNamePrefix="react-select"
                                                        styles={{
                                                            ...reactSelectStyles,
                                                            menuPortal: (base) => ({ ...base, zIndex: 99999999 }),
                                                        }}
                                                        menuPortalTarget={document.body}
                                                    />

                                                    {errors.cashBankAccount && (
                                                        <p className="text-danger">{errors.cashBankAccount}</p>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="row mt-3">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Upload Deposit Slip<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        className="form-control fm-modal"
                                                        onChange={(e) => {
                                                            const file = e.target.files[0];
                                                            setCashDepositSlip(file);
                                                            handleInputChange("cashDepositSlip", file); // validate
                                                        }}
                                                    />
                                                    {errors.cashDepositSlip && (
                                                        <p className="text-danger">{errors.cashDepositSlip}</p>
                                                    )}
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    {selectedPaymentMode?.value === "UPI in Bank" && (
                                        <>


                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Select Bank Account<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <Select
                                                        options={bankAccountOptions}
                                                        value={upiInBankAccount}
                                                        onChange={(selected) => {
                                                            setUpiInBankAccount(selected); // ✅ store full selected object
                                                            handleInputChange("upiInBankAccount", selected);
                                                        }}
                                                        placeholder="Choose Cash Bank Account..."
                                                        className="react-select-container"
                                                        classNamePrefix="react-select"
                                                        styles={{
                                                            ...reactSelectStyles,
                                                            menuPortal: (base) => ({ ...base, zIndex: 99999999 }),
                                                        }}
                                                        menuPortalTarget={document.body}
                                                    />

                                                    {errors.upiInBankAccount && (
                                                        <p className="text-danger">{errors.upiInBankAccount}</p>
                                                    )}
                                                </div>
                                            </div>


                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Transactions Number<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="text"
                                                        className="form-control fm-modal"
                                                        value={utrNumberUpiInBank}
                                                        onChange={(e) => handleInputChange("utrNumberUpiInBank", e.target.value)}
                                                        placeholder="Enter Transactions number"
                                                    />
                                                    {errors.utrNumberUpiInBank && <p className="text-danger">{errors.utrNumberUpiInBank}</p>}
                                                </div>
                                            </div>

                                            <div className="row mt-3">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Upload Deposit Slip<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        className="form-control fm-modal"
                                                        onChange={(e) => {
                                                            const file = e.target.files[0];
                                                            setUpiInBankDepositSlip(file);
                                                            handleInputChange("upinInBankDepositSlip", file); // validate
                                                        }}
                                                    />
                                                    {errors.upinInBankDepositSlip && (
                                                        <p className="text-danger">{errors.upinInBankDepositSlip}</p>
                                                    )}
                                                </div>
                                            </div>

                                        </>
                                    )}
                                    {selectedPaymentMode?.value === "Cheque" && (
                                        <>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Cheque Number<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="text"
                                                        className="form-control fm-modal"
                                                        value={chequeNumber}
                                                        placeholder="Enter cheque number"
                                                        onChange={(e) => handleInputChange("chequeNumber", e.target.value)}
                                                    />
                                                    {errors.chequeNumber && <p className="text-danger">{errors.chequeNumber}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Bank Name<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <Select
                                                        options={bankOptions}
                                                        value={bankOptions.find(b => b.value === chequeBankId) || null}

                                                        onChange={(bank) => handleInputChange("chequeBankId", bank?.value || "")}
                                                        placeholder="Select bank..."
                                                        isSearchable
                                                        styles={reactSelectStyles}
                                                    />
                                                    {errors.chequeBankId && <p className="text-danger">{errors.chequeBankId}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        IFSC Code<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="text"
                                                        className="form-control fm-modal"
                                                        value={ifscCode}
                                                        onChange={(e) => handleInputChange("ifscCode", e.target.value)}
                                                        placeholder="Enter IFSC code"
                                                    />
                                                    {errors.ifscCode && <p className="text-danger">{errors.ifscCode}</p>}
                                                </div>
                                            </div>



                                            <div className="row mt-3">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Upload Cheque Image
                                                        <span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        className="form-control fm-modal"
                                                        onChange={(e) => {
                                                            const file = e.target.files[0];
                                                            handleInputChange("chequeImage", file);
                                                        }}
                                                    />
                                                    {errors.chequeImage && <p className="text-danger">{errors.chequeImage}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Cheque Date<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="date"
                                                        className="form-control fm-modal"
                                                        value={chequeDate}
                                                        onChange={(e) => setChecqueDate(e.target.value)}
                                                        placeholder="Enter IFSC code"
                                                        min={new Date().toISOString().split("T")[0]}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    {selectedPaymentMode?.value === "Demand Draft" && (
                                        <>
                                            {/* DD Number */}
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Demand Draft Number<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="text"
                                                        className="form-control fm-modal"
                                                        value={ddNumber}
                                                        onChange={(e) => {
                                                            const onlyDigits = e.target.value.replace(/\D/g, "");
                                                            handleInputChange("ddNumber", onlyDigits);
                                                        }}
                                                        placeholder="Enter DD number"
                                                    />
                                                    {errors.ddNumber && <p className="text-danger">{errors.ddNumber}</p>}
                                                </div>
                                            </div>

                                            {/* Bank Name */}
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Bank Name<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">

                                                    <Select
                                                        options={bankOptions}
                                                        value={bankOptions.find(b => b.value === ddBankId) || null}
                                                        onChange={(bank) => handleInputChange("ddBankId", bank?.value || "")}
                                                        placeholder="Select bank..."
                                                        isSearchable
                                                        styles={reactSelectStyles}
                                                    />
                                                    {errors.ddBankId && <p className="text-danger">{errors.ddBankId}</p>}
                                                </div>
                                            </div>

                                            {/* Issuing Branch Name */}
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Issuing Branch Name<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="text"
                                                        className="form-control fm-modal"
                                                        value={issuingBranchId}
                                                        onChange={(e) => handleInputChange("issuingBranchId", e.target.value)}
                                                        placeholder="Enter issuing branch..."
                                                    />
                                                    {errors.issuingBranchId && (
                                                        <p className="text-danger">{errors.issuingBranchId}</p>
                                                    )}


                                                </div>
                                            </div>

                                            {/* Date of Issuing */}
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Date of Issuing<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="date"
                                                        className="form-control fm-modal"
                                                        value={ddIssuingDate}
                                                        onChange={(e) => handleInputChange("ddIssuingDate", e.target.value)}
                                                        // min={new Date().toISOString().split("T")[0]}
                                                        max={new Date().toISOString().split("T")[0]}
                                                    // issuing date can't be in future
                                                    />
                                                    {errors.ddIssuingDate && (
                                                        <p className="text-danger">{errors.ddIssuingDate}</p>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Payee Name */}
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Payee Name<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="text"
                                                        className="form-control fm-modal"
                                                        value={ddpayeeName}
                                                        onChange={(e) => {
                                                            const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                                                            handleInputChange("ddpayeeName", onlyLetters);
                                                        }}
                                                        placeholder="Enter payee name"
                                                    />
                                                    {errors.ddpayeeName && (
                                                        <p className="text-danger">{errors.ddpayeeName}</p>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Payable At */}
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Payable At<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="text"
                                                        className="form-control fm-modal"
                                                        value={payAbleAt}
                                                        onChange={(e) => {
                                                            const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                                                            handleInputChange("payAbleAt", onlyLetters);
                                                        }}
                                                        placeholder="Enter city/location"
                                                    />
                                                    {errors.payAbleAt && <p className="text-danger">{errors.payAbleAt}</p>}
                                                </div>
                                            </div>

                                            {/* Upload DD Image */}
                                            <div className="row mt-3">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Upload DD Image<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        className="form-control fm-modal"
                                                        onChange={(e) => {
                                                            const file = e.target.files[0];
                                                            handleInputChange("ddImage", file);
                                                        }}
                                                    />
                                                    {errors.ddImage && <p className="text-danger">{errors.ddImage}</p>}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    {selectedPaymentMode?.value === "Cheque in Bank" && (
                                        <>
                                            {/* Select Bank Account */}
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Select Account<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <Select
                                                        options={bankAccountOptions}
                                                        value={chequeBankAccount}
                                                        onChange={(selected) => {
                                                            setChequeBankAccount(selected);
                                                            handleInputChange("chequeBankAccount", selected);
                                                        }}
                                                        placeholder="Choose Bank Account..."
                                                        className="react-select-container"
                                                        classNamePrefix="react-select"
                                                        styles={{
                                                            ...reactSelectStyles,
                                                            menuPortal: base => ({ ...base, zIndex: 99999999 })
                                                        }}
                                                        menuPortalTarget={document.body}
                                                    />
                                                    {errors.chequeBankAccount && <p className="text-danger">{errors.chequeBankAccount}</p>}
                                                </div>
                                            </div>

                                            {/* Upload Deposit Slip */}
                                            <div className="row mt-3">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Upload Deposit Slip<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        className="form-control fm-modal"
                                                        onChange={(e) => {
                                                            const file = e.target.files[0];
                                                            setChequeDepositSlip(file);
                                                            handleInputChange("chequeDepositSlip", file);
                                                        }}
                                                    />
                                                    {errors.chequeDepositSlip && <p className="text-danger">{errors.chequeDepositSlip}</p>}
                                                </div>
                                            </div>

                                            {/* Cheque Number */}
                                            <div className="row mt-3">
                                                <div className="col-md-4">
                                                    <label className="form-labell">Cheque Number<span className="astrisk">*</span></label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="text"
                                                        className="form-control fm-modal"
                                                        value={chequeNumber}
                                                        placeholder="Enter cheque number"
                                                        onChange={(e) => handleInputChange("chequeNumber", e.target.value)}
                                                    />
                                                    {errors.chequeNumber && <p className="text-danger">{errors.chequeNumber}</p>}
                                                </div>
                                            </div>

                                            {/* Bank Name */}
                                            <div className="row mt-3">
                                                <div className="col-md-4">
                                                    <label className="form-labell">Bank Name<span className="astrisk">*</span></label>
                                                </div>
                                                <div className="col-md-8">
                                                    <Select
                                                        options={bankOptions}
                                                        value={bankOptions.find(b => b.value === chequeBankId) || null}
                                                        onChange={(bank) => handleInputChange("chequeBankId", bank?.value || "")}
                                                        placeholder="Select bank..."
                                                        isSearchable
                                                        styles={reactSelectStyles}
                                                    />
                                                    {errors.chequeBankId && <p className="text-danger">{errors.chequeBankId}</p>}
                                                </div>
                                            </div>

                                            {/* IFSC Code */}
                                            <div className="row mt-3">
                                                <div className="col-md-4">
                                                    <label className="form-labell">IFSC Code<span className="astrisk">*</span></label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="text"
                                                        className="form-control fm-modal"
                                                        value={ifscCode}
                                                        onChange={(e) => handleInputChange("ifscCode", e.target.value)}
                                                        placeholder="Enter IFSC code"
                                                    />
                                                    {errors.ifscCode && <p className="text-danger">{errors.ifscCode}</p>}
                                                </div>
                                            </div>

                                            {/* Upload Cheque Image */}
                                            <div className="row mt-3">
                                                <div className="col-md-4">
                                                    <label className="form-labell">Upload Cheque Image<span className="astrisk">*</span></label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        className="form-control fm-modal"
                                                        onChange={(e) => {
                                                            const file = e.target.files[0];
                                                            setChequeImage(file);
                                                            handleInputChange("chequeImage", file);
                                                        }}
                                                    />
                                                    {errors.chequeImage && <p className="text-danger">{errors.chequeImage}</p>}
                                                </div>
                                            </div>

                                            {/* Cheque Date */}
                                            <div className="row mt-3">
                                                <div className="col-md-4">
                                                    <label className="form-labell">Cheque Date<span className="astrisk">*</span></label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="date"
                                                        className="form-control fm-modal"
                                                        value={chequeDate}
                                                        onChange={(e) => setChecqueDate(e.target.value)}
                                                        min={new Date().toISOString().split("T")[0]}
                                                    />
                                                    {errors.chequeDate && <p className="text-danger">{errors.chequeDate}</p>}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    {selectedPaymentMode?.value === "Demand Draft in Bank" && (
                                        <>
                                            {/* Select Bank Account */}
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Select Account<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <Select
                                                        options={bankAccountOptions}
                                                        value={ddBankAccount}
                                                        onChange={(selected) => {
                                                            setDdBankAccount(selected);
                                                            handleInputChange("ddBankAccount", selected);
                                                        }}
                                                        placeholder="Choose Account..."
                                                        className="react-select-container"
                                                        classNamePrefix="react-select"
                                                        styles={{
                                                            ...reactSelectStyles,
                                                            menuPortal: base => ({ ...base, zIndex: 99999999 })
                                                        }}
                                                        menuPortalTarget={document.body}
                                                    />
                                                    {errors.ddBankAccount && <p className="text-danger">{errors.ddBankAccount}</p>}
                                                </div>
                                            </div>

                                            {/* Upload Deposit Slip */}
                                            <div className="row mt-3">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Upload Deposit Slip<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        className="form-control fm-modal"
                                                        onChange={(e) => {
                                                            const file = e.target.files[0];
                                                            setDdDepositSlip(file);
                                                            handleInputChange("ddDepositSlip", file);
                                                        }}
                                                    />
                                                    {errors.ddDepositSlip && <p className="text-danger">{errors.ddDepositSlip}</p>}
                                                </div>
                                            </div>

                                            {/* DD Number */}
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">Demand Draft Number<span className="astrisk">*</span></label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="text"
                                                        className="form-control fm-modal"
                                                        value={ddNumber}
                                                        onChange={(e) => {
                                                            const onlyDigits = e.target.value.replace(/\D/g, "");
                                                            setDdNumber(onlyDigits);
                                                            handleInputChange("ddNumber", onlyDigits);
                                                        }}
                                                        placeholder="Enter DD number"
                                                    />
                                                    {errors.ddNumber && <p className="text-danger">{errors.ddNumber}</p>}
                                                </div>
                                            </div>

                                            {/* Bank Name */}
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">Bank Name<span className="astrisk">*</span></label>
                                                </div>
                                                <div className="col-md-8">
                                                    <Select
                                                        options={bankOptions}
                                                        value={bankOptions.find(b => b.value === ddBankId) || null}
                                                        onChange={(bank) => {
                                                            setDdBankId(bank?.value || "");
                                                            handleInputChange("ddBankId", bank?.value || "");
                                                        }}
                                                        placeholder="Select bank..."
                                                        isSearchable
                                                        styles={reactSelectStyles}
                                                    />
                                                    {errors.ddBankId && <p className="text-danger">{errors.ddBankId}</p>}
                                                </div>
                                            </div>

                                            {/* Issuing Branch Name */}


                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">
                                                        Issuing Branch Name<span className="astrisk">*</span>
                                                    </label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="text"
                                                        className="form-control fm-modal"
                                                        value={issuingBranchId}
                                                        onChange={(e) => {
                                                            setIssuingBranchId(e.target.value);
                                                            handleInputChange("issuingBranchId", e.target.value);
                                                        }}

                                                        placeholder="Enter issuing branch..."
                                                    />
                                                    {errors.issuingBranchId && (
                                                        <p className="text-danger">{errors.issuingBranchId}</p>
                                                    )}


                                                </div>
                                            </div>


                                            {/* Date of Issuing */}
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">Date of Issuing<span className="astrisk">*</span></label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="date"
                                                        className="form-control fm-modal"
                                                        value={ddIssuingDate}
                                                        onChange={(e) => {
                                                            setDdIssuingDate(e.target.value);
                                                            handleInputChange("ddIssuingDate", e.target.value);
                                                        }}
                                                        max={new Date().toISOString().split("T")[0]} // issuing date can't be in future
                                                    />
                                                    {errors.ddIssuingDate && <p className="text-danger">{errors.ddIssuingDate}</p>}
                                                </div>
                                            </div>

                                            {/* Payee Name */}
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">Payee Name<span className="astrisk">*</span></label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="text"
                                                        className="form-control fm-modal"
                                                        value={ddpayeeName}
                                                        onChange={(e) => {
                                                            const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                                                            setDdPayeeName(onlyLetters);
                                                            handleInputChange("ddpayeeName", onlyLetters);
                                                        }}
                                                        placeholder="Enter payee name"
                                                    />
                                                    {errors.ddpayeeName && <p className="text-danger">{errors.ddpayeeName}</p>}
                                                </div>
                                            </div>

                                            {/* Payable At */}
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className="form-labell">Payable At<span className="astrisk">*</span></label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="text"
                                                        className="form-control fm-modal"
                                                        value={payAbleAt}
                                                        onChange={(e) => {
                                                            const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                                                            setPayAbleAt(onlyLetters);
                                                            handleInputChange("payAbleAt", onlyLetters);
                                                        }}
                                                        placeholder="Enter city/location"
                                                    />
                                                    {errors.payAbleAt && <p className="text-danger">{errors.payAbleAt}</p>}
                                                </div>
                                            </div>

                                            {/* Upload DD Image */}
                                            <div className="row mt-3">
                                                <div className="col-md-4">
                                                    <label className="form-labell">Upload DD Image<span className="astrisk">*</span></label>
                                                </div>
                                                <div className="col-md-8">
                                                    <input
                                                        type="file"
                                                        accept="image/*,.pdf"
                                                        className="form-control fm-modal"
                                                        onChange={(e) => {
                                                            const file = e.target.files[0];
                                                            setDDImage(file);
                                                            handleInputChange("ddImage", file);
                                                        }}
                                                    />
                                                    {errors.ddImage && <p className="text-danger">{errors.ddImage}</p>}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    {(selectedPaymentMode?.value === "NEFT" ||
                                        selectedPaymentMode?.value === "RTGS" || selectedPaymentMode?.value === "IMPS") && (
                                            <>

                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <label className="form-labell">
                                                            UTR Number<span className="astrisk">*</span>
                                                        </label>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <input
                                                            type="text"
                                                            className="form-control fm-modal"
                                                            value={utrNumber}
                                                            onChange={(e) => handleInputChange("utrNumber", e.target.value)}
                                                            placeholder="Enter UTR number"
                                                        />
                                                        {errors.utrNumber && <p className="text-danger">{errors.utrNumber}</p>}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <label className="form-labell">
                                                            Select Bank Account<span className="astrisk">*</span>
                                                        </label>
                                                    </div>
                                                    <div className="col-md-8">

                                                        <Select
                                                            options={bankAccountOptions}
                                                            value={cashBankAccount}
                                                            onChange={(selected) => {
                                                                setCashBankAccount(selected); // ✅ store full selected object
                                                                handleInputChange("bankAccount", selected);
                                                            }}
                                                            placeholder="Choose Cash Bank Account..."
                                                            className="react-select-container"
                                                            classNamePrefix="react-select"
                                                            styles={{
                                                                ...reactSelectStyles,
                                                                menuPortal: (base) => ({ ...base, zIndex: 99999999 }),
                                                            }}
                                                            menuPortalTarget={document.body}
                                                        />
                                                        {errors.bankAccount && <p className="text-danger">{errors.bankAccount}</p>}
                                                    </div>
                                                </div>
                                            </>

                                        )}

                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="form-labell">
                                                Amount<span className="astrisk">*</span>
                                            </label>
                                        </div>
                                        <div className="col-md-8">
                                            <input
                                                type="text"
                                                min="0"
                                                className="form-control fm-modal"
                                                value={amount}
                                                ref={amountRef}
                                                onChange={(e) => {
                                                    const cleaned = e.target.value.replace(/[^0-9]/g, '');
                                                    setAmount(cleaned);
                                                }}
                                                onKeyDown={handleKeyPress}
                                                placeholder="Enter amount"
                                                disabled={isCrmStudent}
                                                readOnly={isCrmStudent}
                                                title={isCrmStudent ? 'Amount is fixed by the Career Arc inquiry and cannot be changed.' : undefined}
                                                style={isCrmStudent ? { backgroundColor: '#f5f5f5', cursor: 'not-allowed' } : undefined}
                                            />
                                            {isCrmStudent && (
                                                <small style={{ color: '#7F56DA', display: 'block', marginTop: '4px' }}>
                                                    Locked to CRM Student amount
                                                </small>
                                            )}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="form-labell">Amount in words</label>
                                        </div>
                                        <div className="col-md-8 mt-3"  >
                                            <p ><strong style={{ color: "#7F56DA", fontWeight: "bold" }} >{numberToWords(calculateTotal()).toUpperCase()} ONLY</strong></p>
                                        </div>
                                    </div>


                                    <div className="mt-3">
                                        <div className="mb-3">

                                            {/* Toggle Header */}
                                            <div
                                                className="d-flex justify-content-between align-items-center p-2 bg-light border rounded"
                                                onClick={() => setShowLedger(!showLedger)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <h6 className="mb-0">Ledger Summary</h6>
                                                <span>{showLedger ? "▲" : "▼"}</span>
                                            </div>

                                            {/* Ledger Table */}
                                            {showLedger && (
                                                <div className="mt-2 paymentreporttablecontainer ledgerWrapper"
                                                    style={{
                                                        maxHeight: "300px",
                                                        overflowY: "auto",
                                                        border: "1px solid #ddd",
                                                        borderRadius: "6px"
                                                    }}>
                                                    <table
                                                        className="table table-sm table-bordered table-hover student-table fee ledgerTable"

                                                    >
                                                        {/* Sticky Header */}
                                                        <thead
                                                            className="ledgerHeader"
                                                        >
                                                            <tr>
                                                                <th style={{ padding: "10px", borderBottom: "2px solid #d0d0d0" }}>Date</th>
                                                                {/* <th style={{ padding: "10px", borderBottom: "2px solid #d0d0d0" }}>Mode Of Payment</th>*/}
                                                                <th style={{ padding: "10px", borderBottom: "2px solid #d0d0d0" }}>Particular</th>
                                                                <th style={{ padding: "10px", textAlign: "right", borderBottom: "2px solid #d0d0d0" }}>Debit</th>
                                                                <th style={{ padding: "10px", textAlign: "right", borderBottom: "2px solid #d0d0d0" }}>Credit</th>
                                                                <th style={{ padding: "10px", textAlign: "right", borderBottom: "2px solid #d0d0d0" }}>Balance</th>
                                                            </tr>
                                                        </thead>


                                                        {/* Body (same logic retained) */}
                                                        <tbody className="ledgerBody">
                                                            {unifiedEntries.length > 0 ? (
                                                                (() => {
                                                                    let runningBalance = 0;

                                                                    return unifiedEntries.map((item, idx) => {
                                                                        if (item.entryType === "Credit") {
                                                                            runningBalance += item.amount;
                                                                        } else if (item.entryType === "Debit") {
                                                                            runningBalance -= item.amount;
                                                                        }

                                                                        return (
                                                                            <tr key={idx}>
                                                                                <td style={{ padding: "10px" }}>
                                                                                    {item.entryType === "Credit" && item.payment_date
                                                                                        ? formatDateDDMMYYYYHHMMSS_UTC(item.payment_date)
                                                                                        : formatDateDDMMYYYYHHMMSS_UTC(item.created_at)}
                                                                                </td>


                                                                                <td style={{ padding: "10px" }}>
                                                                                    {item.entryType === "Debit"
                                                                                        ? (item.fee_head?.name || "-")
                                                                                        : (
                                                                                            <>
                                                                                                {item.mode_of_payment}

                                                                                                {item.transaction?.cheque_number && <div><strong>Cheque:</strong> {item.transaction.cheque_number}</div>}
                                                                                                {item.transaction?.dd_number && <div><strong>DD:</strong> {item.transaction.dd_number}</div>}
                                                                                                {item.transaction?.utr_number && <div><strong>UTR:</strong> {item.transaction.utr_number}</div>}
                                                                                            </>
                                                                                        )
                                                                                    }
                                                                                </td>


                                                                                <td style={{ padding: "10px", textAlign: "right" }}>
                                                                                    ₹ {item.entryType === "Debit"
                                                                                        ? Number(item.amount).toLocaleString("en-IN", { minimumFractionDigits: 2 })
                                                                                        : "0.00"}
                                                                                </td>

                                                                                <td style={{ padding: "10px", textAlign: "right" }}>
                                                                                    ₹ {item.entryType === "Credit"
                                                                                        ? Number(item.amount).toLocaleString("en-IN", { minimumFractionDigits: 2 })
                                                                                        : "0.00"}
                                                                                </td>

                                                                                <td style={{ padding: "10px", textAlign: "right" }}>
                                                                                    ₹ {Number(runningBalance).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    });
                                                                })()
                                                            ) : (
                                                                <tr>
                                                                    <td
                                                                        colSpan="6"
                                                                        className="text-center"
                                                                        style={{ padding: "10px" }}
                                                                    >
                                                                        No Ledger Entries Found
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                        <tfoot className="ledgerFooter">
                                                            <tr>
                                                                {/* Empty cells matching Date + Particular columns */}
                                                                <td style={{ padding: "10px" }}></td>
                                                                <td style={{ padding: "10px" }}></td>

                                                                {/* Total Debit */}
                                                                <td style={{ padding: "10px", textAlign: "right" }}>
                                                                    ₹ {Number(totalDebit).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                                </td>

                                                                {/* Total Credit */}
                                                                <td style={{ padding: "10px", textAlign: "right" }}>
                                                                    ₹ {Number(totalCredit).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                                </td>

                                                                {/* Final Balance */}
                                                                <td style={{ padding: "10px", textAlign: "right" }}>
                                                                    ₹ {Number(finalBalance).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                                                                </td>
                                                            </tr>
                                                        </tfoot>


                                                    </table>
                                                </div>
                                            )}

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className="form-actions mt-5"
                        style={{ position: 'sticky', background: 'white', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <button
                            type="submit"
                            disabled={loadingButton || !studentsData?.user_id || !amount}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                cursor:
                                    loadingButton || !studentsData?.user_id || !amount
                                        ? "not-allowed"
                                        : "pointer",
                                backgroundColor:
                                    loadingButton || !studentsData?.user_id || !amount
                                        ? "#d3d3d3"
                                        : "#7F56DA",
                            }}
                            onClick={() => handleReceiveFee("new")}
                        >
                            {loadingButton === "new" ? (
                                <span className="spinner-border spinner-border-sm" role="status" />
                            ) : (
                                "Receive & New"
                            )}
                        </button>

                        <button
                            type="submit"
                            disabled={loadingButton || !studentsData?.user_id || !amount}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                cursor:
                                    loadingButton || !studentsData?.user_id || !amount
                                        ? "not-allowed"
                                        : "pointer",
                                backgroundColor:
                                    loadingButton || !studentsData?.user_id || !amount
                                        ? "#d3d3d3"
                                        : "#7F56DA",
                            }}
                            onClick={() => handleReceiveFee("close")}
                        >
                            {loadingButton === "close" ? (
                                <span className="spinner-border spinner-border-sm" role="status" />
                            ) : (
                                "Receive & Close"
                            )}
                        </button>
                        {/* 
                        {showCancel && (
                            <button
                                type="button"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    cursor: "pointer",
                                    backgroundColor: "red",
                                    color: "white",
                                    padding: "6px 12px",
                                    borderRadius: "6px",
                                    border: "none",
                                }}
                                onClick={cancelCardPayment}
                            >
                                Cancel Payment
                            </button>
                        )} */}
                    </div>
                </div>
            </div>
            {paymentmodal && paymentResponse && (
                <SuccessfulModalPayment
                    mainheading="Payment Success!"
                    paymentResponse={paymentResponse}
                    isOpen={paymentmodal}
                    onClose={() => {
                        setpaymentmodal(false);
                        onClose();
                    }}
                    submitclose={() => {
                        setpaymentmodal(false);
                        if (closePaymentOnSuccess) {
                            // Delay closing parent to avoid focus-trap errors
                            setTimeout(() => onClose(), 50);
                        }
                    }}

                //   submitclose={() => {
                //         setpaymentmodal(false);
                //         if (closePaymentOnSuccess) {
                //             onClose();
                //         }
                //     }}
                />
            )}

        </>
    );
};
